var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHutricsLogoColor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 699.36 163.63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#05547f;}.cls-2{fill:#ec4d0a;}.cls-3{fill:#29abe2;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 111.87,
    y: 28.8,
    width: 30.58,
    height: 6,
    transform: "translate(12.5 95.3) rotate(-43.02)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 53.69,
    y: 21.99,
    width: 6,
    height: 29.39,
    transform: "translate(-9.5 50.04) rotate(-44.32)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 20.5,
    y: 94.04,
    width: 39.75,
    height: 6,
    transform: "translate(-49.03 41.78) rotate(-35.69)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M243.17,90.05h-9.61v-25.72h-46.47v25.72h-9.61V32.04h9.61v23.55h46.47v-23.55h9.61v58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M333.86,71.3c0,6.04-2.96,10.96-8.89,14.78-5.93,3.82-13.89,5.73-23.88,5.73s-17.97-1.92-23.96-5.77c-5.98-3.85-8.97-8.76-8.97-14.74V32.04h9.61v36.93c0,4.54,1.99,8.01,5.97,10.42,3.98,2.4,9.76,3.6,17.35,3.6s13.34-1.2,17.27-3.6c3.93-2.4,5.89-5.88,5.89-10.42V32.04h9.61v39.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M414.62,40.77h-27.72v49.27h-9.61V40.77h-27.72v-8.73h65.06v8.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M496.5,90.05h-11.14l-15.7-22.11h-29.32v22.11h-9.61V32.04h45.75c6.09,0,10.87,1.64,14.34,4.93,3.47,3.29,5.21,7.73,5.21,13.34,0,4.92-1.36,8.81-4.09,11.7-2.72,2.88-6.38,4.7-10.98,5.45l15.54,22.59Zm-21.47-30.85c3.58,0,6.33-.77,8.25-2.32,1.92-1.55,2.88-3.74,2.88-6.57,0-6.36-4.01-9.53-12.02-9.53h-33.81v18.43h34.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M527.1,90.05h-9.61V32.04h9.61v58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M620.2,45.26l-8.73,3.12c-5.88-6.25-14.1-9.37-24.68-9.37-8.01,0-14.54,2.06-19.59,6.17-5.05,4.11-7.57,9.35-7.57,15.7s2.5,11.87,7.49,15.9c4.99,4.03,11.74,6.05,20.23,6.05,10.26,0,18.32-3.18,24.2-9.53l8.25,4.57c-4.17,4.86-8.88,8.37-14.14,10.53-5.26,2.16-11.55,3.25-18.87,3.25-10.31,0-18.83-2.56-25.56-7.69-7.75-5.82-11.62-13.51-11.62-23.07s3.93-16.98,11.78-22.91c6.78-5.18,15.25-7.77,25.4-7.77,14.53,0,25.66,5.02,33.41,15.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M689.98,45.66c-8.6-4.38-17.36-6.57-26.28-6.57-5.93,0-10.47,.7-13.62,2.08-3.15,1.39-4.73,3.31-4.73,5.77s1.68,4.43,5.05,5.61c1.87,.64,4.18,1.1,6.93,1.36,2.75,.27,6.14,.52,10.17,.76,4.03,.24,7.54,.55,10.54,.92,7.26,.91,12.63,2.68,16.1,5.33,3.47,2.64,5.21,6.37,5.21,11.18,0,6.14-2.72,10.9-8.17,14.26s-13.27,5.05-23.47,5.05c-14.79,0-26.31-3.26-34.53-9.77l5.29-6.97c9.08,5.56,18.85,8.33,29.32,8.33,6.78,0,12-.91,15.66-2.72,3.66-1.82,5.49-4.33,5.49-7.53,0-1.87-.41-3.36-1.24-4.49s-2.56-2-5.21-2.64c-2.64-.64-4.88-1.05-6.69-1.24-1.82-.19-5.26-.44-10.33-.76-1.5-.11-2.64-.19-3.45-.24-9.56-.64-16.42-2-20.59-4.09-4.17-2.08-6.25-5.77-6.25-11.06s2.55-9.75,7.65-12.9c5.1-3.15,12.3-4.73,21.59-4.73,12.5,0,22.97,2.86,31.41,8.57l-5.85,6.49Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M91.57,109.6c-21.92,0-39.75-17.83-39.75-39.75s17.83-39.75,39.75-39.75,39.75,17.83,39.75,39.75-17.83,39.75-39.75,39.75Zm0-62.5c-12.54,0-22.75,10.21-22.75,22.75s10.21,22.75,22.75,22.75,22.75-10.21,22.75-22.75-10.21-22.75-22.75-22.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M38.64,32.7c-7.72,0-14-6.28-14-14s6.28-14,14-14,14,6.28,14,14-6.28,14-14,14Zm0-22.14c-4.49,0-8.14,3.65-8.14,8.14s3.65,8.14,8.14,8.14,8.14-3.65,8.14-8.14-3.65-8.14-8.14-8.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M146.74,28c-7.72,0-14-6.28-14-14s6.28-14,14-14,14,6.28,14,14-6.28,14-14,14Zm0-22.14c-4.49,0-8.14,3.65-8.14,8.14s3.65,8.14,8.14,8.14,8.14-3.65,8.14-8.14-3.65-8.14-8.14-8.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M14,128.02c-7.72,0-14-6.28-14-14s6.28-14,14-14,14,6.28,14,14-6.28,14-14,14Zm0-22.14c-4.49,0-8.14,3.65-8.14,8.14s3.65,8.14,8.14,8.14,8.14-3.65,8.14-8.14-3.65-8.14-8.14-8.14Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 123.85,
    y: 113.8,
    width: 5.86,
    height: 7.9,
    transform: "translate(-45.6 102.87) rotate(-37.95)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 116.55,
    y: 104.44,
    width: 5.86,
    height: 7.9,
    transform: "translate(-41.39 96.4) rotate(-37.95)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 130.85,
    y: 123.05,
    width: 5.86,
    height: 7.9,
    transform: "translate(-49.82 109.13) rotate(-37.95)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 138.87,
    y: 133.05,
    width: 5.86,
    height: 7.9,
    transform: "translate(-54.27 116.19) rotate(-37.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M152.16,163.63c-7.72,0-14-6.28-14-14s6.28-14,14-14,14,6.28,14,14-6.28,14-14,14Zm0-22.14c-4.49,0-8.14,3.65-8.14,8.14s3.65,8.14,8.14,8.14,8.14-3.65,8.14-8.14-3.65-8.14-8.14-8.14Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHutricsLogoColor);
export default __webpack_public_path__ + "static/media/hutrics-logo-color.9363eefc6e8641e69fac45cb3b95b071.svg";
export { ForwardRef as ReactComponent };